module.exports = __webpack_public_path__ + "img/gauge.0587b784.svg";